import { render, staticRenderFns } from "./Scale_classification.vue?vue&type=template&id=83c8934e"
import script from "./Scale_classification.vue?vue&type=script&lang=js"
export * from "./Scale_classification.vue?vue&type=script&lang=js"
import style0 from "./Scale_classification.vue?vue&type=style&index=0&id=83c8934e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports